import { Row, Col } from "react-bootstrap";
import { RiUser3Fill, RiCalendarLine, RiCheckLine, RiCloseLine, RiTimeLine } from "react-icons/ri";
import { HiOutlineUser } from "react-icons/hi";
import { BsCalendarDate } from "react-icons/bs";
import { FaCheck } from "react-icons/fa6";
import { IoClose } from "react-icons/io5";

export default function DriverStats({analyticsData}) {
   

    return (
        <Row className="da-stats g-2">
            <div className="da-stat-col">
                <div className="da-card">
                    <div className="icon" style={{ background: " #e8f1ff", color: "#2563eb" }}>
                        <HiOutlineUser size={20} />
                    </div>
                    <div>
                        <h4 className="mb-0">{analyticsData?.ongoing || 0}</h4>
                        <p>Active Bookings</p>
                    </div>
                </div>
            </div>

            <div className="da-stat-col">
                <div className="da-card">
                    <div className="icon" style={{ background: "#fff4e5", color: "#f59e0b" }}>
                        <BsCalendarDate size={20} />
                    </div>
                    <div>
                        <h4 className="mb-0">{analyticsData?.total || 0}</h4>
                        <p>Total Bookings</p>
                    </div>
                </div>
            </div>

            <div className="da-stat-col">
                <div className="da-card">
                    <div className="icon" style={{ background: "#e7f8ef", color: "#10b981" }}>
                        <FaCheck size={20} />
                    </div>
                    <div>
                        <h4 className="mb-0">{analyticsData?.completed || 0}</h4>
                        <p>Completed</p>
                    </div>
                    {/* <div><small>{(analyticsData?.completed /analyticsData?.total * 100 ).toFixed(1) || 0}%</small></div> */}
                </div>
            </div>

            <div className="da-stat-col">
                <div className="da-card">
                    <div className="icon" style={{ background: "#f8f6e7", color: "#d2c912" }}>
                        <RiTimeLine size={20} />
                    </div>
                    <div>
                        <h4 className="mb-0">{analyticsData?.upcoming || 0}</h4>
                        <p>Upcoming</p>
                    </div>
                    {/* <div className="text-end align-content-end"><small>{(analyticsData?.upcoming /analyticsData?.total * 100 ).toFixed(1) || 0 }%</small></div> */}

                </div>
            </div>
        </Row >
    );
}